import React from 'react'
import { EmptyStateSize } from 'shared/timber/v1/EmptyState'

import './Icon.scss'
import classy from 'shared/utils/classy'

export interface EmptyStateIconProps {
  size?: EmptyStateSize
  children: React.ReactNode
  appearance?: 'condensed' | 'default'
  'data-testid'?: string
  noMargin?: boolean
}

const EmptyStateIcon = React.memo(
  ({
    size = 'md',
    children,
    appearance = 'default',
    'data-testid': dataTestId = 'empty-state-icon',
    noMargin = false,
  }: EmptyStateIconProps) => {
    return (
      <div
        className={classy(
          'EmptyStateIcon',
          `EmptyStateIcon--${size}`,
          `EmptyStateIcon--${appearance}`,
          noMargin && 'EmptyStateIcon--no-margin',
        )}
        data-appearance={appearance}
        data-testid={dataTestId}
      >
        {children}
      </div>
    )
  },
)

EmptyStateIcon.displayName = 'EmptyState.Icon'

export default EmptyStateIcon
